import { z } from 'zod';

export const FeedbackValidator = z.object({
  rating: z.string(),
  feedback_title: z.string().min(1, {
    message: 'Please enter title.',
  }),
  feedback_content: z.string().min(1, {
    message: 'Please enter content.',
  }),
});

export type FeedbackFormData = z.infer<typeof FeedbackValidator>;
